// src/components/FormDetails.js
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  Container,
  FormControl,
  InputLabel,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { GetAllStates } from '../../screen/auth/action/util_actions';
import { GetAllCityOfState } from '../Onboarding/auth/action';

import {
  IcotermsDropDown,
  OperationType,
  deliveryTypeDropDown,
} from '../../utils/settings';
import DatePicker from 'antd/es/date-picker';
import dayjs from 'dayjs';
import {
  compareProductPricesBetweenTwoPricingGeographyAction,
  compareProductPricesBetweenTwoStatesAction,
} from './Action';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import ShipToPartyDetailsComponents from './ShipToPartyDetailsComponents';
import GoBack from '../Components/GoBack';
import ErrorDialog from '../Components/ErrorDialog';

const ShipToPartyDetails = ({ firm = {} }) => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [firmDetails, setfirmDetails] = useState(firm);
  const [open, handleModalClose] = useState(false);

  const {
    buyerDetails = {},
    editUserData = {},
    isFromEditOrderDetails = false,
    isSellToBuyer = false,
    isEditingSelectedStp = false,
    influencerTabSelected = false,
  } = state;

  const {
    addedUserList,
    booking_details,
    isFmcgFlow,
    isPaintFlow,
    seller_id,
    booking_editorder_details,
  } = useSelector((state) => {
    return {
      addedUserList: state.bcmOrderReducer.addedUserList,
      booking_details: state.bcmOrderReducer.booking_details,
      isFmcgFlow: state.bcmOrderReducer.isFmcgFlow,
      isPaintFlow: state.bcmOrderReducer.isPaintFlow,
      seller_id: state.bcmOrderReducer.seller_id,
      booking_editorder_details:
        state.bcmOrderReducer.booking_editorder_details,
    };
  });
  useEffect(() => {
    if (Object.keys(firmDetails).length > 0) {
      setBuyer({ ...firmDetails });
    }
  }, [firmDetails]);

  const [buyer, setBuyer] = useState({
    ...buyerDetails,
    delivery_type:
      isFmcgFlow || isPaintFlow ? null : deliveryTypeDropDown[0].value,
    delivery_district_id: buyerDetails?.district_id,
    delivery_Address_line1: firm?.company_address1,
    delivery_Address_line2: firm?.company_address2,
    delivery_Address_line3: firm?.company_address3,
    location_id: firm?.location_id,
    location_name: firm?.location_name,
    pricing_geography_id: firm?.pricing_geography_id,
    pricing_geography_name: firm?.pricing_geography_name,
  });
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [checked, setChecked] = useState(true);

  useEffect(() => {
    if (isFromEditOrderDetails && Object.keys(editUserData).length > 0) {
      const test = {
        company_name: editUserData?.company_name,
        company_id: editUserData?.company_id,
        company_phone_no: editUserData?.company_phone_no,
        company_type: editUserData?.company_type,
        company_address: editUserData?.company_address,
        company_pincode: editUserData?.company_pincode,
        district_id: editUserData?.district_id,
        state_id: editUserData?.state_id,
        pancard_no: editUserData?.pancard_no,
        gstin: editUserData?.gstin,
        dispatch_date: dayjs(editUserData?.dispatch_date) || dayjs(),
        ...editUserData,
      };
      setBuyer(test);
    }
  }, [isFromEditOrderDetails]);

  const validateBuyerFields = () => {
    const requiredFields = [
      { key: 'delivery_district_id', label: 'Delivery District' },
      { key: 'delivery_location_id', label: 'Delivery Location' },
      {
        key: 'delivery_pricing_geography_id',
        label: 'Delivery Geography Pricing',
      },
      { key: 'delivery_company_pincode', label: 'Delivery Pincode' },
      { key: 'delivery_Address_line1', label: 'Delivery Address Line 1' },
    ];

    for (const field of requiredFields) {
      if (
        buyer[field.key] === null ||
        buyer[field.key] === undefined ||
        buyer[field.key] === ''
      ) {
        toast.error(`Please fill in the ${field.label}`);
        return false;
      }
    }
    return true;
  };

  const getStates = async () => {
    const { data, error, message } = await GetAllStates();

    if (!error) {
      setStates(
        data.map((state) => ({
          label: state.state_name,
          value: state.id,
        })),
      );
    } else {
      return toast.error(message);
    }
  };

  const getDistricts = async (stateId) => {
    setDistricts([]);

    const { data, error, message } = await GetAllCityOfState(stateId);

    if (!error) {
      setDistricts(
        data.map((district) => ({
          label: district.district_name,
          value: district.id,
        })),
      );
    } else return toast.error(message);
  };

  const priceComparison = async (
    currentPricingGeographyID,
    prevPricingGeographyId,
  ) => {
    const payload = {
      pricing_geography_id_1: prevPricingGeographyId,
      pricing_geography_id_2: currentPricingGeographyID,
      product_company_id: booking_details.seller_company_id || seller_id,
    };

    if (isPaintFlow) {
      payload.product_company_id = seller_id;
    }
    const response = await compareProductPricesBetweenTwoPricingGeographyAction(
      payload,
    );
    return response;
  };

  const addNewUser = () => {
    dispatch({
      type: 'ADD_USER_TO_LIST',
      data: buyer,
    });

    navigate('/order-booking/selected-ship-to-party-list');
  };

  const keys = (address) => [
    address.pricing_geography_name,
    address.delivery_company_pincode,
    address.delivery_location_name,
    address.delivery_Address_line1,
    address.delivery_Address_line2,
    address.delivery_Address_line3,
  ];

  const isDuplicateAddress = addedUserList.some((userItem) => {
    const userKeys = keys(userItem).map((key) => String(key).toLowerCase());
    const buyerKeys = keys(buyer).map((key) => String(key).toLowerCase());

    return buyerKeys.every((key, index) => key === userKeys[index]);
  });

  const onAddUser = async () => {
    const index = addedUserList.findIndex(
      (vv) => vv.company_id === buyer.company_id,
    );
    if (index !== -1) {
      if (isDuplicateAddress) {
        handleModalClose(true);
        return;
      }
    }

    if (addedUserList.length > 0) {
      const { data, error, message } = await priceComparison(
        buyer?.delivery_pricing_geography_id,
        addedUserList[0]?.delivery_pricing_geography_id,
      );
      if (!error) {
        if (data.result) {
          addNewUser();
        } else {
          return toast.error(
            'Price comparison failed.You need to create a new Dispatch Plan as price is different for this District',
          );
        }
      } else return toast.error('Something went wrong');
    } else {
      addNewUser();
    }
  };
  const onAddUserFromDetails = async () => {
    const existingShipmentIndex =
      booking_editorder_details?.shipment_details.findIndex(
        (vv) => vv?.ship_to_party_info?.company_info?.id === buyer?.company_id,
      );
    if (existingShipmentIndex !== -1) {
      const existingShipment =
        booking_editorder_details.shipment_details[existingShipmentIndex];
      if (
        existingShipment.ship_to_party_info?.address_info?.address
          .address_line_1 === buyer?.delivery_Address_line1 &&
        existingShipment.ship_to_party_info?.address_info?.address
          .address_line_2 === buyer?.delivery_Address_line2 &&
        existingShipment.ship_to_party_info?.address_info?.address
          .address_line_3 === buyer?.delivery_Address_line3 &&
        existingShipment.ship_to_party_info?.address_info?.pincode ===
          buyer?.delivery_company_pincode &&
        existingShipment.ship_to_party_info?.location_info?.location_id ===
          buyer?.delivery_location_id
      ) {
        return toast.error('User already added');
      }
    }

    const addNewUser = () => {
      const obj = {
        ship_to_party_info: {
          so_id: null,
          operation_type: OperationType['ADD'],
          company_info: {
            id: buyer?.company_id,
            name: buyer?.company_name,
            phone: buyer?.company_phone_no,
            gst: buyer?.gstin,
          },
          address_info: {
            address: {
              address_line_1: buyer?.delivery_Address_line1,
              address_line_2: buyer?.delivery_Address_line2,
              address_line_3: buyer?.delivery_Address_line3,
            },
            pincode: buyer?.delivery_company_pincode,
          },
          location_info: {
            location_id: buyer?.delivery_location_id,
            location_name: buyer?.delivery_location_name,
          },
          pricing_geography_info: {
            pricing_geography_id: buyer?.delivery_pricing_geography_id,
            pricing_geography_name: buyer?.delivery_pricing_geography_name,
          },
          district_info: {
            id: buyer.delivery_district_id,
            name: buyer.delivery_district_name,
          },
          state_info: {
            id: buyer?.state_id,
            name: buyer?.state_name,
          },
          contact_person_info: {
            name: buyer?.delivery_contact_person_name,
            phone_number: buyer?.delivery_contact_person_phone,
          },
          delivery_info: {
            delivery_type: buyer?.delivery_type,
            requested_dispatch_date: dayjs(buyer?.dispatch_date).format(
              'YYYY-MM-DD',
            ),
          },
        },
        product_summary_keys: [
          'Name',
          'UoM',
          'Delivered',
          'Pending',
          'GST %',
          'UoM Ex GST Price',
          'Total Ex GST',
        ],
        product_summary_info: [],
        invoice_url: null,
      };
      dispatch({
        type: 'ADD_USER_EDIT_PO_BOOKING_DETAILS',
        data: obj,
      });
      navigate(-2);
      //   navigation.navigate('DispatchPlan');
    };

    if (booking_editorder_details.shipment_details.length > 0) {
      const { data, error, message } = await priceComparison(
        buyer?.delivery_pricing_geography_id,
        booking_editorder_details.shipment_details[0].ship_to_party_info
          .pricing_geography_info.pricing_geography_id,
      );
      if (!error) {
        if (data.result) {
          addNewUser();
        } else {
          return toast.error(
            'Price comparison failed.You need to create a new Dispatch Plan as price is different for this District',
          );
        }
      } else return toast.error('Something went wrong');
    } else {
      addNewUser();
    }
  };

  const onUpdateUserFromDetails = () => {
    const obj = {
      ship_to_party_info: {
        so_id: buyer?.ship_to_party_info?.so_id,
        operation_type:
          buyer?.ship_to_party_info?.operation_type === OperationType['ADD']
            ? OperationType['ADD']
            : OperationType['UPDATE'],
        company_info: {
          id: buyer?.company_id,
          name: buyer?.company_name,
          phone: buyer?.company_phone_no,
          gst: buyer?.gstin,
        },
        address_info: {
          address: {
            address_line_1: buyer?.delivery_Address_line1,
            address_line_2: buyer?.delivery_Address_line2,
            address_line_3: buyer?.delivery_Address_line3,
          },
          pincode: buyer?.delivery_company_pincode,
        },
        location_info: {
          location_id: buyer?.delivery_location_id,
          location_name: buyer?.delivery_location_name,
        },
        pricing_geography_info: {
          pricing_geography_id: buyer?.delivery_pricing_geography_id,
          pricing_geography_name: buyer?.delivery_pricing_geography_name,
        },
        district_info: {
          id: buyer.delivery_district_id,
          name: buyer.delivery_district_name,
        },
        state_info: {
          id: buyer?.state_id,
          name: buyer?.state_name,
        },
        contact_person_info: {
          name: buyer?.delivery_contact_person_name,
          phone_number: buyer?.delivery_contact_person_phone,
        },
        delivery_info: {
          delivery_type: buyer?.delivery_type,
          requested_dispatch_date: dayjs(buyer?.dispatch_date).format(
            'YYYY-MM-DD',
          ),
        },
      },
      product_summary_keys: buyer?.product_summary_keys,
      product_summary_info: buyer?.product_summary_info,
      invoice_url: buyer?.invoice_url,
    };

    const data = [
      ...booking_editorder_details.shipment_details.filter(
        (item) => item.ship_to_party_info.company_info.id !== buyer?.company_id,
      ),
      obj,
    ];
    dispatch({
      type: 'UPDATE_USER_EDIT_PO_BOOKING_DETAILS',
      data: data,
    });
    navigate(-1);
    // navigation.goBack();
  };

  const onUpdateUser = () => {
    if (isFmcgFlow) {
      dispatch({
        type: 'SET_SELECTED_STP',
        data: buyer,
      });
      navigate('/order-booking/selected-ship-to-party-list');
    } else {
      dispatch({
        type: 'UPDATE_USER_TO_LIST',
        data: buyer,
      });

      navigate('/order-booking/selected-ship-to-party-list');
    }
  };

  const isEditingUser = Object.keys(editUserData).length > 0;
  useEffect(() => {
    if (buyer.state_id) getDistricts(buyer.state_id);
  }, [buyer.state_id]);

  useEffect(() => {
    getStates();
  }, []);

  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pt: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          backgroundColor: '#f5f5f5',
        }}
      >
        <ShipToPartyDetailsComponents
          firm={
            isFromEditOrderDetails && Object.keys(editUserData).length > 0
              ? editUserData
              : buyerDetails
          }
          setBuyerDetails={(e) => {
            setBuyer((prev) => ({
              ...prev,
              ...e,
            }));
          }}
          isSellToBuyer={isSellToBuyer}
          editFirm={
            isFromEditOrderDetails && Object.keys(editUserData).length > 0
          }
          influencerTabSelected={influencerTabSelected}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
            mb: '2rem',
          }}
        >
          {isSellToBuyer ? (
            <Button
              variant='contained'
              color='primary'
              onClick={() => {
                dispatch({
                  type: 'SET_SELECTED_STP',
                  data: buyer,
                });

                if (isEditingSelectedStp) navigate(-1);
                else navigate(-2);
              }}
            >
              {isEditingSelectedStp ? 'Update' : 'Add'} Buyer
            </Button>
          ) : (
            <>
              {!isFromEditOrderDetails && (
                <Button
                  variant='outlined'
                  color='primary'
                  sx={{
                    width: '20%',
                    fontWeight: 'bold',
                    backgroundColor: 'Background',
                  }}
                  onClick={() =>
                    navigate('/order-booking/selected-ship-to-party-list')
                  }
                >
                  Go To Ship To Party List
                </Button>
              )}
              <Button
                variant='contained'
                color='primary'
                sx={{
                  width: '20%',
                  fontWeight: 'bold',
                }}
                onClick={() => {
                  if (validateBuyerFields()) {
                    if (isEditingUser) {
                      if (isFromEditOrderDetails) onUpdateUserFromDetails();
                      else onUpdateUser();
                    } else {
                      if (isFromEditOrderDetails) onAddUserFromDetails();
                      else onAddUser();
                    }
                  }
                }}
              >
                {'Save'}
              </Button>
            </>
          )}
        </Box>
      </Container>
      {open && (
        <ErrorDialog
          title={'User already added'}
          text={'View Ship to Party List'}
          open={open}
          handleModalClose={handleModalClose}
          onClick={'/order-booking/selected-ship-to-party-list'}
        />
      )}
    </>
  );
};

export default ShipToPartyDetails;
